var _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesLeftSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 282,
    viewBox: "0 0 190 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 202.5,
    r: 79.5,
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 98C117 130.309 90.8087 156.5 58.5 156.5C26.1913 156.5 0 130.309 0 98C0 65.6913 26.1913 39.5 58.5 39.5C90.8087 39.5 117 65.6913 117 98Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 39.5,
    r: 39.5,
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesLeftSide);
export default __webpack_public_path__ + "static/media/circlesLeftSide.43fe37237201b92b4e261ea1206f573d.svg";
export { ForwardRef as ReactComponent };